export default function(number) {
  return new Intl.NumberFormat().format(number).toLocaleString()
}